import { NavItemButton } from '@/domain/navigation/features/navigation/components/MobileNavItem/NavItem';
import { useNews } from '@/domain/navigation/features/navigation/hooks/useNews/useNews';
import { SubMenuType } from '@/domain/navigation/features/navigation/mobile/MobileMenuItem/types';
import { useTranslation } from 'react-i18next';

export function NewsfeedNavItem({
  setActiveSubmenu,
}: {
  setActiveSubmenu: (type: SubMenuType) => void;
}) {
  const { t } = useTranslation();
  const { news } = useNews();
  const unreadItemsCount = news.filter((item) => !item.istGelesen).length;

  return (
    <NavItemButton onClick={() => setActiveSubmenu('news')}>
      <div className="flex items-center w-full justify-between mr-2">
        {t('general.navigation.profileDropdown.news')}
        {unreadItemsCount > 0 && (
          <div className="rounded-full size-5 bg-primary-blue-B600 text-white text-xs leading-3 flex items-center justify-center">
            {unreadItemsCount}
          </div>
        )}
      </div>
    </NavItemButton>
  );
}
